import { Modal } from '@trackman/web-shared-components';
import { FileManager } from '../../MediaLibrary/MediaLibrary';
import { useEffect, useState } from 'react';

import '../../../../pages/Admin/Admin.scss';
import '../AdminModal.scss';
import './FileManagerModal.scss';
import { useStores } from 'index';
import { FileNode, isFile, Node } from '../../../../types/admin/nodes';
import { observer } from 'mobx-react-lite';

type Props = {
  open: boolean;
  onClose: (selectedFile: FileNode | undefined) => void;
};

export const FileManagerModal = observer(({ open, onClose }: Props) => {
  const fileManagerStore = useStores().mediaLibraryStore;

  const [selectedFile, setSelectedFile] = useState<FileNode | undefined>(undefined);

  useEffect(() => {
    fileManagerStore.fetchNodes();
  }, [fileManagerStore]);

  const handleNodesSelected = (nodes: Node[]) => {
    const files = nodes.filter(isFile);

    if (files.length !== 1) {
      setSelectedFile(undefined);
    } else {
      setSelectedFile(files[0]);
    }
  };

  const confirm = () => {
    onClose(selectedFile);
  };

  const handleClose = () => {
    onClose(undefined);
  };

  return (
    <Modal
      title='File Manager'
      open={open}
      onClose={handleClose}
      cancelBtn={{
        label: 'Close',
        onClick: handleClose,
      }}
      confirmBtn={{
        label: 'Select',
        onClick: confirm,
        disabled: !selectedFile,
      }}
      className='admin-modal admin-file-manager-modal'
    >
      <FileManager onNodesSelected={handleNodesSelected} />
    </Modal>
  );
});
